import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './AboutUs.css';

const AboutUs = () => {
  const featuredLeader = {
    name: 'Dr. Darryl Williams',
    role: 'Founder, CEO & Chief Scientist',
    image: '/team/darryl-williams.jpeg',
    bio: "Dr. Darryl R. Williams is the Founder, CEO, and Chief Scientist of Partsol, a Tampa-based software company specializing in Cognitive AI solutions. With over 30 years of experience, he has led initiatives addressing complex challenges for government agencies and Fortune 500 companies. A retired U.S. Air Force Lieutenant Colonel, Dr. Williams holds a Doctorate in Business Administration from the University of Phoenix and an MBA in International Finance from Auburn University. His expertise encompasses supply chain risk assessments, infrastructure vulnerability analysis, and cybersecurity initiatives."
  };

  const teamMembers = [
    {
      id: 1,
      name: 'Dr. Darryl Williams',
      role: 'Founder, CEO & Chief Scientist',
      image: '/team/darryl-williams.jpeg',
      bio: "Dr. Darryl R. Williams is the Founder, CEO, and Chief Scientist of Partsol, a Tampa-based software company specializing in Cognitive AI solutions. With over 30 years of experience, he has led initiatives addressing complex challenges for government agencies and Fortune 500 companies. A retired U.S. Air Force Lieutenant Colonel, Dr. Williams holds a Doctorate in Business Administration from the University of Phoenix and an MBA in International Finance from Auburn University. His expertise encompasses supply chain risk assessments, infrastructure vulnerability analysis, and cybersecurity initiatives."
    },
    // Row 1
    {
      id: 2,
      name: 'John Callahan',
      role: 'CTO',
      image: '/team/john-callahan.jpg',
      bio: "John Callahan serves as the Chief Technology Officer for Partsol, where he is responsible for operational strategy and management of Partsol, as well as serving as the technical lead on conceptual design, research, and development. Prior to joining Partsol, Callahan was Managing Executive for Strategic Initiatives at the Information Sciences Institute, a premier global research facility primarily known for the creation of ARPANET (forerunner to the Internet). John also co-founded the Holland Computing Center and spent two decades helping lead ad-hoc US government special projects in defense, intelligence, counterterrorism, deterrence, cyber, and medicine."
    },
    {
      id: 3,
      name: 'Alan Williams',
      role: 'President, Partsol Futures',
      image: '/team/alan-williams.jpeg',
      bio: "Alan Williams serves as the President of Partsol Futures, the strategic innovation arm of Partsol focused on accelerating breakthrough applications of Cognitive AI. Under his leadership, the Futures Lab drives the development of deployable, enterprise-grade AI solutions across national security, smart infrastructure, life sciences, and advanced education. He has more than 30 years of experience in sales management and executive account management."
    },
    {
      id: 4,
      name: 'James Shore',
      role: 'CFO',
      image: '/team/james-shore.jpg',
      bio: "James Shore serves as the Chief Financial Officer at Partsol. Prior to joining Partsol, Mr. Shore began his career at Ernst Young before transitioning to Strategic Finance Leadership and CFO roles at multinational public companies including Home Depot, Jones Lang LaSalle, and Arris. Most recently, Mr. Shore has held CFO roles at multiple Family Office and Private Equity backed companies, with a focus on high-growth scaling, fundraising, and M&A initiatives."
    },
    {
      id: 5,
      name: 'Brad Topchik',
      role: 'EVP Corporate Development',
      image: '/team/brad-topchik.jpeg',
      bio: "Brad Topchik serves as Executive Vice President of Corporate Development at Partsol, where he leads strategic initiatives focused on growth through partnerships, market expansion, and mergers and acquisitions. Brad also oversees the company's capital raising efforts and manages investor relations. Brad brings to Partsol over 30 years of experience advising growth-stage software companies. He holds a BA in Political Science from Columbia University and an MBA from Columbia Business School."
    },
    // Row 2
    {
      id: 6,
      name: 'Brian Rau',
      role: 'Chief Operating Officer',
      image: '/team/brian-rau.jpeg',
      bio: "Brian Rau serves as the COO, where he oversees all operational facets of the company, working collaboratively with the CEO and executive team to align strategies with organizational goals. He leads teams across finance, marketing, human resources, and operations, ensuring efficient and seamless day-to-day operations. A retired Army officer, Brian brings a wealth of discipline and leadership to his role. He holds a bachelor's degree from Florida State University, a master's degree from Webster University, and is a SHRM Certified Professional® (SHRM-CP)."
    },
    {
      id: 7,
      name: 'Manuel "Mac" Capello',
      role: 'CISO',
      image: '/team/mac-capello.jpg',
      bio: "Mac Capello serves as the Chief Information Security Officer, leading the effort in safeguarding the company's information. With more than two decades of expertise in offensive and defensive information security operations, security engineering, and risk analysis, Mac combines technical expertise with strategic vision to protect against the evolving threat landscape."
    },
    {
      id: 8,
      name: 'James Goggins',
      role: 'EVP Partsol Guilds',
      image: '/team/james-goggins.jpg',
      bio: "James Goggins is the Executive Vice President of Partsol Guild at Partsol, where he spearheads strategic growth initiatives, develops high-performing sales organizations, and elevates client engagement to new heights. With over three decades of leadership experience and a history of operational excellence, James excels at driving transformative solutions that consistently surpass business objectives."
    },
    {
      id: 9,
      name: 'Eric Nielsen',
      role: 'EVP Partsol Futures',
      image: '/team/eric-nielsen.jpeg',
      bio: "Eric Nielsen is the Executive Vice President at Partsol Futures. He is responsible for operationalizing cognitive-AI breakthroughs by embedding reliability, compliance, and scalability so leaders can act with certainty in their most critical decisions. With nearly two decades at the intersection of cyber-security, data governance, and AI-enabled innovation, he has overseen enterprise security and privacy programs for multibillion-dollar organizations across healthcare, retail, and fintech."
    },
    // Row 3
    {
      id: 10,
      name: 'Jared Williams',
      role: 'EVP Special Projects',
      image: '/team/jared-williams.jpg',
      bio: "Jared Williams serves as the Executive Vice President of Special Projects at Partsol, where he leads critical initiatives and special assignments that drive the company's strategic objectives forward."
    },
    {
      id: 12,
      name: 'Dale Wright',
      role: 'VP, Product',
      image: '/team/dale-wright.jpeg',
      bio: "Dale Wright is the Vice President of Product at Partsol, where he leads product strategy, integrates customer insights, and drives cross-functional collaboration. He brings a wealth of leadership experience and a disciplined approach to innovation based on his decades of service. He holds a Bachelor of Science in Liberal Arts from Excelsior University and served 26 years in the U.S. Navy retiring as a Senior Chief Cryptologist."
    }
  ];

  const boardOfDirectors = [
    {
      id: 13,
      name: 'Dr. Darryl Williams',
      role: 'Founder/Director'
    },
    {
      id: 14,
      name: 'Marie Williams',
      role: 'Founder/Director'
    },
    {
      id: 15,
      name: 'Jared Williams',
      role: 'Founder/Director'
    },
    {
      id: 16,
      name: 'Dr. Samuel Dawson',
      role: 'Independent Director'
    },
    {
      id: 17,
      name: 'Marc Bern',
      role: 'Independent Director'
    }
  ];

  const [selectedMember, setSelectedMember] = useState(null);

  const openModal = (member) => {
    setSelectedMember(member);
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  const navigateMember = (direction) => {
    const currentIndex = teamMembers.findIndex(m => m.id === selectedMember.id);
    let newIndex;
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % teamMembers.length;
    } else {
      newIndex = (currentIndex - 1 + teamMembers.length) % teamMembers.length;
    }
    setSelectedMember(teamMembers[newIndex]);
  };

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <p className="about-hero-label">Our Team</p>
          <h1 className="about-hero-title">Meet the People Behind Partsol</h1>
          <p className="about-hero-subtitle">
            Our team combines deep expertise in AI, data science, and industry-specific knowledge
            to deliver solutions that transform decision-making.
          </p>
        </div>
      </section>

      {/* Featured Leader Section */}
      <section className="featured-leader-section">
        <div className="featured-leader-container">
          <div className="featured-leader-content">
            <div className="featured-image-wrapper">
              <img src={featuredLeader.image} alt={featuredLeader.name} className="featured-image" />
            </div>
            <div className="featured-info">
              <span className="featured-label">Meet Our Founder</span>
              <h2 className="featured-name">{featuredLeader.name}</h2>
              <p className="featured-role">{featuredLeader.role}</p>
              <p className="featured-bio">{featuredLeader.bio}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-team">
        <div className="team-container">
          <h2 className="team-section-title">Leadership Team</h2>
          <div className="team-grid">
            {teamMembers.slice(1).map((member) => (
              <div
                key={member.id}
                className="team-member"
                onClick={() => openModal(member)}
              >
                <div className="member-image-wrapper">
                  <img src={member.image} alt={member.name} className="member-image" />
                </div>
                <h3 className="member-name">{member.name}</h3>
                <p className="member-role">{member.role}</p>
              </div>
            ))}
          </div>

          {/* Board of Directors */}
          <div className="board-of-directors">
            <h3 className="directors-title">Board of Directors</h3>
            <div className="directors-list">
              {boardOfDirectors.map((director) => (
                <div key={director.id} className="director-item">
                  <h4 className="director-name">{director.name}</h4>
                  <p className="director-role">{director.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Modal */}
      {selectedMember && (
        <div className="team-modal-overlay" onClick={closeModal}>
          <div className="team-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <X size={24} />
            </button>

            <div className="modal-content">
              <div className="modal-text">
                <h3 className="modal-name">{selectedMember.name}</h3>
                <p className="modal-role">{selectedMember.role}</p>
                <p className="modal-bio">{selectedMember.bio}</p>

                <div className="modal-nav">
                  <button className="modal-nav-btn" onClick={() => navigateMember('prev')}>
                    <ChevronLeft size={20} />
                  </button>
                  <button className="modal-nav-btn" onClick={() => navigateMember('next')}>
                    <ChevronRight size={20} />
                  </button>
                </div>
              </div>

              <div className="modal-image-wrapper">
                <img src={selectedMember.image} alt={selectedMember.name} className="modal-image" />
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="about-cta">
        <div className="cta-container">
          <h2>Ready to Experience Absolute Truth?</h2>
          <p>Discover how Partsol's Cognitive AI can transform your decision-making process.</p>
          <Link to="/contact" className="cta-button">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
